import React, { FC } from 'react'
import { makeStyles } from '@material-ui/styles'
import classNames from 'classnames'

import StylesModule from 'components/lv3/topBgImage.module.scss'
import TopMainBGImg from 'images/rooms/main.jpg'
import CrossBg from 'images/cross-bg.svg'
import Logo from 'images/logo-on-text.svg'
import { MessageProps } from 'message/index.props'

export interface TopImageProps {
  message: MessageProps
  lang: string
}

const useStyles = makeStyles(() => ({
  bgImage: {
    backgroundImage: `url(${TopMainBGImg})`,
  },
  crossBgImage: {
    backgroundImage: `url(${CrossBg})`,
  },
}))

const TopImage: FC<TopImageProps> = ({ message, lang }) => {
  const classes = useStyles()
  let topBgImageLang = ''
  switch (lang) {
    case 'ja':
      topBgImageLang = 'topBgImageJa'
      break
    case 'en':
      topBgImageLang = 'topBgImageEn'
      break
  }
  console.log(topBgImageLang)
  return (
    <section
      className={classNames(
        classes.bgImage,
        StylesModule[topBgImageLang],
        StylesModule.topBgImage,
      )}
    >
      <div
        className={classNames(
          classes.crossBgImage,
          StylesModule.topBgImage__cover,
        )}
      >
        <div className={StylesModule.topBgImage__wrap}>
          <p className={StylesModule.topBgImage__title}>
            {message.top.renewal_open_day.title}
          </p>
          <p
            className={StylesModule.topBgImage__text}
            dangerouslySetInnerHTML={{
              __html: message.top.renewal_open_day.text,
            }}
          />
          <div className={StylesModule.topBgImage__logoWrap}>
            <img
              src={Logo}
              alt={message.top.kasuien}
              className={StylesModule.topBgImage__logo}
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default TopImage
